import React, { Component } from 'react';
import { render } from 'react-dom';
import axios from 'axios';
import routes from './routes';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { Provider } from 'react-redux';
import createStore from './store/createStore';
import { persistStore } from 'redux-persist';
import immutableTransform from 'redux-persist-transform-immutable';
import Raven from 'raven-js';
import { sentry_dsn } from './sentry';

// Install Sentry
// eslint-disable-next-line
if (process.env.NODE_ENV === 'production') {
    Raven.config(sentry_dsn).install();
}

// Axios Config Interceptors
axios.interceptors.request.use(function (config) {
    if (localStorage.getItem('token') != null) {
        let access = localStorage.getItem('token');
        config.headers['Authorization'] = 'Bearer ' + access;
    }

    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

const store = createStore();
const history = syncHistoryWithStore(browserHistory, store);

class Root extends Component {
    constructor() {
        super();
        this.state = { rehydrated: false };
    }

    componentWillMount(){
        persistStore(store, {transforms: [immutableTransform()], blacklist: ['routing']}, () => {
            this.setState({ rehydrated: true });
        });
    }

    render() {
        if(!this.state.rehydrated){
            return <div>Loading...</div>
        }

        return (
            <Provider store={store}>
                <Router history={history} routes={routes} />
            </Provider>
        )
    }
}

render(<Root />,
    document.getElementById('root'));


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/